import { render, staticRenderFns } from "./ProductAdvantages.vue?vue&type=template&id=3809f89e&scoped=true&"
import script from "./ProductAdvantages.vue?vue&type=script&lang=js&"
export * from "./ProductAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./ProductAdvantages.vue?vue&type=style&index=0&id=3809f89e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809f89e",
  null
  
)

export default component.exports